import React, { memo } from 'react';

import { ForecastingGridTable } from './forecasting-grid-table';
import useExpandableRows from './hooks/use-expandable-rows';

/**
 * ForecastingGrid component that displays inventory forecasting data in a table
 * @returns {React.ReactElement} The rendered ForecastingGrid component
 */
const ForecastingGrid = () => {
  const { expandedRows, handleRowExpand } = useExpandableRows();

  return <ForecastingGridTable expandedRows={expandedRows} handleRowExpand={handleRowExpand} />;
};

export default memo(ForecastingGrid);
